// # Place all the behaviors and hooks related to the matching controller here.
// # All this logic will automatically be available in application.js.
// # You can use CoffeeScript in this file: http://coffeescript.org/
$(function() {
  if (!$("#select_push_check").attr("checked")) {
    $("#push_box").slideToggle();
  }
  $('.new_or_edit_magazine_issue').on('change', 'input[type=file]', function(e) {
    var filename, id;
    id = e.target.id;
    if (e.target.files.length !== 0) {
      filename = e.target.files[0].name;
      $("." + id).remove();
      if ($(e.target).parent().attr('class') === 'drop_file_zone') {
        return $(e.target).parent().after("<span class='" + id + "'><br>" + filename + "</span>");
      } else {
        return $(e.target).parent().parent().after("<span class='" + id + "'><br>" + filename + "</span>");
      }
    } else {
      return $("." + id).remove();
    }
  });
  return $('#select_push_check').on('click', function(e) {
    return $("#push_box").slideToggle(this.checked);
  });
});

// ---
// generated by coffee-script 1.9.2
